import CustomNode from '../../Pages/Operation/CustomNode';

const nodeTypes = {
  custom: CustomNode,
}

export default nodeTypes;